import * as React from 'react'

import { cn } from '@/lib/utils'

interface InputProps extends React.ComponentProps<'input'> {
  error?: string
  inputClassName?: string
  variant?: 'default' | 'outline'
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, inputClassName, type, error, variant = 'default', ...props }, ref) => {
    return (
      <div className={cn('relative', error && 'mb-2', className)}>
        <input
          type={type}
          className={cn([
            'file:text-foreground text-tracking-tight bg-foreground/5 text-foreground placeholder:text-foreground/40 hover:bg-foreground/7 focus:bg-foreground/7 flex h-11 w-full px-5 py-3.5 text-sm transition-[color,background-color,border-color] duration-200 outline-none file:bg-transparent file:text-sm file:font-medium disabled:cursor-not-allowed disabled:opacity-50',
            variant === 'default' && 'focus:border-foreground/40 border border-transparent',
            variant === 'outline' &&
              'focus:border-foreground/40 border-foreground/10 h-10 border bg-transparent',
            inputClassName,
            props.readOnly && 'cursor-default border-0',
          ])}
          ref={ref}
          {...props}
        />
        {error && <p className="text-destructive absolute top-full left-2 mt-2 text-sm">{error}</p>}
      </div>
    )
  }
)
Input.displayName = 'Input'

export { Input, type InputProps }
